var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCbChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#2F2E79",
    strokeWidth: 2,
    d: "M1 1h21v21H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E79",
    d: "M17.62 5l-8.67 9.012-3.57-3.675L3 12.787 8.95 19 20 7.538z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbChecked);
export default __webpack_public_path__ + "static/media/cb_checked.c5968f488f6477025fe1feee36444594.svg";
export { ForwardRef as ReactComponent };